__turbopack_context__.v({
  "active": "gmRu1a_active",
  "add-to-cart-btn": "gmRu1a_add-to-cart-btn",
  "add-to-wishlist": "gmRu1a_add-to-wishlist",
  "backChevron": "gmRu1a_backChevron",
  "backLink": "gmRu1a_backLink",
  "backText": "gmRu1a_backText",
  "btn-container": "gmRu1a_btn-container",
  "checkbox-container": "gmRu1a_checkbox-container",
  "copy-wishlist-link": "gmRu1a_copy-wishlist-link",
  "create-wishlist-item": "gmRu1a_create-wishlist-item",
  "delete-container": "gmRu1a_delete-container",
  "dropdown-content": "gmRu1a_dropdown-content",
  "dropdown-label": "gmRu1a_dropdown-label",
  "edit-icon": "gmRu1a_edit-icon",
  "edit-link": "gmRu1a_edit-link",
  "form-checkbox": "gmRu1a_form-checkbox",
  "move-wishlist-link": "gmRu1a_move-wishlist-link",
  "nav-list-item": "gmRu1a_nav-list-item",
  "no-wishlist-items": "gmRu1a_no-wishlist-items",
  "private": "gmRu1a_private",
  "product-image-block": "gmRu1a_product-image-block",
  "product-name": "gmRu1a_product-name",
  "product-select-action": "gmRu1a_product-select-action",
  "profileHeading": "gmRu1a_profileHeading",
  "profileTitle": "gmRu1a_profileTitle",
  "select-icon": "gmRu1a_select-icon",
  "share-wishlist-container": "gmRu1a_share-wishlist-container",
  "share-wishlist-main": "gmRu1a_share-wishlist-main",
  "share-wishlist-subtitle": "gmRu1a_share-wishlist-subtitle",
  "share-wishlist-title": "gmRu1a_share-wishlist-title",
  "sharemodal-actions": "gmRu1a_sharemodal-actions",
  "sharemodal-container": "gmRu1a_sharemodal-container",
  "sharemodal-outline-button": "gmRu1a_sharemodal-outline-button",
  "sharemodal-subtitle": "gmRu1a_sharemodal-subtitle",
  "sharemodal-success-container": "gmRu1a_sharemodal-success-container",
  "sharemodal-success-info": "gmRu1a_sharemodal-success-info",
  "sharemodal-title": "gmRu1a_sharemodal-title",
  "total-item-count": "gmRu1a_total-item-count",
  "wishlist-action-bottom": "gmRu1a_wishlist-action-bottom",
  "wishlist-action-grid": "gmRu1a_wishlist-action-grid",
  "wishlist-add-cart": "gmRu1a_wishlist-add-cart",
  "wishlist-collection-subtitle": "gmRu1a_wishlist-collection-subtitle",
  "wishlist-container": "gmRu1a_wishlist-container",
  "wishlist-content-head": "gmRu1a_wishlist-content-head",
  "wishlist-content-title": "gmRu1a_wishlist-content-title",
  "wishlist-create-btn-container": "gmRu1a_wishlist-create-btn-container",
  "wishlist-create-subtitle": "gmRu1a_wishlist-create-subtitle",
  "wishlist-drawer": "gmRu1a_wishlist-drawer",
  "wishlist-drawer-collection": "gmRu1a_wishlist-drawer-collection",
  "wishlist-drawer-title": "gmRu1a_wishlist-drawer-title",
  "wishlist-drawer-toast-overlay": "gmRu1a_wishlist-drawer-toast-overlay",
  "wishlist-dropdown": "gmRu1a_wishlist-dropdown",
  "wishlist-empty-subtitle": "gmRu1a_wishlist-empty-subtitle",
  "wishlist-empty-title": "gmRu1a_wishlist-empty-title",
  "wishlist-error": "gmRu1a_wishlist-error",
  "wishlist-head": "gmRu1a_wishlist-head",
  "wishlist-hidden-mobile": "gmRu1a_wishlist-hidden-mobile",
  "wishlist-hidden-wrapper": "gmRu1a_wishlist-hidden-wrapper",
  "wishlist-info": "gmRu1a_wishlist-info",
  "wishlist-items-container": "gmRu1a_wishlist-items-container",
  "wishlist-nav": "gmRu1a_wishlist-nav",
  "wishlist-nav-list": "gmRu1a_wishlist-nav-list",
  "wishlist-product-grid": "gmRu1a_wishlist-product-grid",
  "wishlist-product-img-link": "gmRu1a_wishlist-product-img-link",
  "wishlist-product-price": "gmRu1a_wishlist-product-price",
  "wishlist-shared-action": "gmRu1a_wishlist-shared-action",
  "wishlist-shared-container": "gmRu1a_wishlist-shared-container",
  "wishlist-shared-header": "gmRu1a_wishlist-shared-header",
  "wishlist-sharemodal": "gmRu1a_wishlist-sharemodal",
  "wishlist-sidebar-action-container": "gmRu1a_wishlist-sidebar-action-container",
  "wishlist-sidebar-btn": "gmRu1a_wishlist-sidebar-btn",
  "wishlist-sidebar-collection": "gmRu1a_wishlist-sidebar-collection",
  "wishlist-sidebar-container": "gmRu1a_wishlist-sidebar-container",
  "wishlist-sidebar-empty": "gmRu1a_wishlist-sidebar-empty",
  "wishlist-title": "gmRu1a_wishlist-title",
  "wishlist-toolbar-action": "gmRu1a_wishlist-toolbar-action",
  "wishlist-toolbar-actions": "gmRu1a_wishlist-toolbar-actions",
  "wishlist-toolbar-actions-container": "gmRu1a_wishlist-toolbar-actions-container",
  "wishlist-toolbar-name": "gmRu1a_wishlist-toolbar-name",
  "wishlist-toolbar-sharebutton": "gmRu1a_wishlist-toolbar-sharebutton",
  "wishlist-top-toolbar": "gmRu1a_wishlist-top-toolbar",
});
